import { COMMON_BLOCK_ATTRIBUTES } from "../../constants";

const attributes = {
	clientId: {
		type: "string",
	},
	alignment: {
		type: "object",
		style: [{ selector: "{{WRAPPER}} {justify-content: {{VALUE}}; }" }],
	},
	columnGap: {
		type: "object",
		default: {
			desktop: {
				value: 10,
				unit: "px",
			},
		},
		style: [
			{
				selector:
					"{{WRAPPER}} .mzb-social-links .block-editor-block-list__layout, {{WRAPPER}} {column-gap: {{VALUE}}; }",
			},
		],
	},
	border: {
		type: "object",
		default: {
			border: 1,
			radius: { desktop: { lock: true } },
			size: { desktop: { lock: true } },
		},
		style: [{ selector: "{{WRAPPER}} .mzb-social-icon a" }],
	},
	boxShadow: {
		type: "object",
		default: { boxShadow: 1 },
		style: [{ selector: "{{WRAPPER}} .mzb-social-icon a" }],
	},
	backgroundColor: {
		type: String,
		style: [
			{
				selector:
					"{{WRAPPER}} .mzb-social-icon a {background-color: {{VALUE}}}",
			},
		],
	},
	...COMMON_BLOCK_ATTRIBUTES,
};

export default attributes;
